import { createTheme } from '@mui/material/styles';


// Determining the used colors and pallette
const theme = createTheme({
    palette: {
        primary: {
            main: '#4a8bd4',
            cyan: '#507f8d',
            light1: '#43AFF5',
            light2: '#eefbff',
            light3: '#f3f9ff',
            lightgrey: '#edf1f7',
            lightcyan: '#a1fae0',
            grey: '#898989',
            dark1: '#222629',
            blue: '#004085',
            bluegrey: '#343a40',
            bluegreylight: '#c9c1b9'
        },
        red: {
            main: '#d45a4a',
            light: '#f8d7da',
            dark: '#a93728',
            contrastText: '#FFF',
        },
        blue: {
            main: '#1236F3', //Blue
            light: '#00ff94', //Teal
            dark: '#5200ff', //Blue/purple
            // main: '#ffa978', //orange
            contrastText: '#000',

        },
    },
    typography: {
        button: {
            textTransform: 'none'
        },
        fontFamily: [
            "Poppins",
            'sans-serif'
        ].join(','),
    },

});

export default theme;